// extracted by mini-css-extract-plugin
export default {"container":"Map_container__QO6mI","image":"Map_image__e2zgY"};